export const USER_STATE_CHANGE                  = 'USER_STATE_CHANGE'
export const USER_DATEIN_STATE_CHANGE           = 'USER_DATEIN_STATE_CHANGE'
export const USER_DATECHANGE_STATE_CHANGE       = 'USER_DATECHANGE_STATE_CHANGE'
export const USER_DATECHANGEFINAL_STATE_CHANGE  = 'USER_DATECHANGEFINAL_STATE_CHANGE'
export const USER_DATECHANGEINICIO_STATE_CHANGE = 'USER_DATECHANGEINICIO_STATE_CHANGE'
export const USER_MENU_STATE_CHANGE             = 'USER_MENU_STATE_CHANGE'
export const USER_TASK_STATE_CHANGE             = 'USER_TASK_STATE_CHANGE'
export const USER_CLIENTID_CHANGE               = 'USER_CLIENTID_CHANGE'
export const USER_TOKEN_STATE_CHANGE            = 'USER_TOKEN_STATE_CHANGE'
export const USER_ENTRANTES_STATE_CHANGE        = 'USER_ENTRANTES_STATE_CHANGE'
export const USER_SALIENTES_STATE_CHANGE        = 'USER_SALIENTES_STATE_CHANGE'
export const USER_FECTHINIT_STATE_CHANGE        = 'USER_FECTHINIT_STATE_CHANGE'
export const USER_LEFTANEXOS_STATE_CHANGE       = 'USER_LEFTANEXOS_STATE_CHANGE'
export const USER_RIGHTANEXOS_STATE_CHANGE      = 'USER_RIGHTANEXOS_STATE_CHANGE'
export const USER_LEFTANEXOS2_STATE_CHANGE       = 'USER_LEFTANEXOS_STATE_CHANGE'
export const USER_RIGHTANEXOS2_STATE_CHANGE      = 'USER_RIGHTANEXOS_STATE_CHANGE'
export const USER_ERRORSTATE_STATE_CHANGE       = 'USER_ERRORSTATE_STATE_CHANGE'
export const USER_LOADERROR_STATE_CHANGE           = 'USER_LOADERROR_STATE_CHANGE'
export const PESELECT_STATE_CHANGE               = 'PESELECT_STATE_CHANGE'
export const IDBUSCAR_STATE_CHANGE               = 'IDBUSCAR_STATE_CHANGE'
export const ACTUALIZAR_LISTA                       = 'ACTUALIZAR_LISTA'
export const OPEN_REDUX                             = 'OPEN_REDUX';
export const CLIENTES_REDUX                     = 'CLIENTES_REDUX';
export const  CLIENTES_REDUX_REPORT             = 'CLIENTES_REDUX_REPORT';
export const CLEAR_DATA                          = 'CLEAR_DATA'


